const mistakes = [
  'руководитель начинает переговоры без подготовки;',
  'слишком быстро делает уступку, не выяснив интересы другой стороны;',
  'путает твёрдость с агрессией и давлением;',
  'боится испортить отношения и избегает необходимого разговора;',
  'пытается доказать свою правоту вместо поиска решения;',
  'говорит вместо того, чтобы задавать вопросы;',
  'не выясняет интересы другой стороны;',
  'угрожает последствиями, которые не собирается реализовывать;',
  'не определяет границы допустимого;',
  'не фиксирует договорённости;',
  'оставляет слишком много пространства для разных трактовок;',
  'продолжает переговоры после достижения достаточного результата.',
];

export default function ManagerMistakes() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Типичные ошибки руководителей
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Что снижает переговорную позицию руководителя и мешает добиться результата
        </p>

        <div className="grid sm:grid-cols-2 gap-3">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}